import './Tracking.scss';
import Component from './Tracking.js';
export default Component;